"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isServerSide = void 0;
/**
 * Returns whether or not the code is running on the server side.
 */
var isServerSide = function () { return typeof window === 'undefined'; };
exports.isServerSide = isServerSide;
//# sourceMappingURL=utils.js.map